import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '@/lib/api';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    async function handleSubmit(e: FormEvent) {
        e.preventDefault();
        setSubmitting(true);
        try {
            await authApi.forgotPassword(email.trim());
            setDone(true);
        } catch {
            // Backend responde 200 igual; un error acá es de red — mostramos done igual.
            setDone(true);
        } finally {
            setSubmitting(false);
        }
    }

    if (done) {
        return (
            <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50 dark:bg-gray-900">
                <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-6 text-center">
                    <div className="text-4xl mb-4" aria-hidden="true">📧</div>
                    <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Revisa tu correo</h1>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-6">
                        Si el correo <strong>{email}</strong> está registrado, te enviamos un link
                        para restablecer tu contraseña. El link expira en 30 minutos.
                    </p>
                    <Link
                        to="/login"
                        className="inline-block px-4 py-2 bg-brand-blue text-white rounded-lg font-medium hover:bg-brand-blue-dark"
                    >
                        Volver al login
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50 dark:bg-gray-900">
            <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-6">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Recuperar contraseña</h1>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-6">
                    Ingresá el correo de tu cuenta y te enviaremos un link para restablecerla.
                </p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        label="Correo electrónico"
                        type="email"
                        required
                        autoFocus
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="tu@correo.cl"
                    />
                    <Button type="submit" loading={submitting} disabled={!email.trim()} className="w-full">
                        Enviar link
                    </Button>
                </form>
                <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-6">
                    <Link to="/login" className="text-brand-blue hover:underline">← Volver al login</Link>
                </p>
            </div>
        </div>
    );
}
